/*
 * Site entry point
 */

import './scss/normalize.scss';
import './scss/main.scss';
import './scss/container.scss';
import './scss/btn.scss';

import '../components/*/index.js';
import '../components/*/style.scss';

import './videos';
import './images';